import i18n from "@/providers/i18n";

import type { AuthError } from "@supabase/supabase-js";

export const getAuthErrorMessage = (error: AuthError): string => {
  switch (error.code) {
    case "same_password":
      return i18n.t("notify.error-reason.auth.same_password");
    case "weak_password":
      return i18n.t("notify.error-reason.auth.weak_password");
    default:
      return error.message;
  }
};
